const messages = {
  AIDOO : {
    title: 'Aidoo',
    desc: 'Dispositivo per la gestione ed integrazione di unità interne singole ad espansione diretta e per produzione d\'acqua: <br/> · Wi-Fi <br/> · KNX',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6xxxxxx.png',
    articles: {
      AIDOO_WIFI: {
        title: 'Aidoo Wi-Fi',
        desc:  'Dispositivo per la gestione di unità interna individuale. Controllo dall\'app Airzone Aidoo, collegamento Wi-Fi e integrazione Modbus.',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6WSCxxx.png',
        descResult: 'Controlla le impostazioni della tua unità d\'aria condizionata da qualunque parte del mondo usando la nostra app <b>Airzone Aidoo</b> (disponibile per <a href="https://play.google.com/store/apps/details?id=es.airzone.aidoo" target="_blank" style="color:#007f9b">Android</a> e <a href="https://apps.apple.com/app/airzone-aidoo/id1468065088" target="_blank" style="color:#007f9b">iOS</a>). Compatibile con:',
        logos: [
          'https://doc.airzone.es/Resources/Images/IMG_logo-Google-Assistant.png',
          'https://doc.airzone.es/Resources/Images/IMG_logo-Alexa.png',
        ],
      },
      AIDOO_KNX: {
        title: 'Aidoo KNX',
        desc: 'Dispositivo per la gestione di unità interna individuale. Integrazione con KNX TP-1. Tre ingressi digitali configurabili.',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6KNXxxx.png',
        descResult: 'Compatibile con il software ETS5, puoi configurare facilmente Aidoo KNX e aggiungerlo al tuo progetto. Scarica il nostro <a href="https://doc.airzone.es/producto/Gama_AZ6/Airzone/Aidoo/BBDD_AZAI6KNX.zip" style="color:#007f9b">database</a>.',
      }
    },
    include: {
      protocolo: '%{protocolo} %{article}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a> with:',
      accesrories: [
        'Cavo di collegamento Aidoo  - unità interna.',
        'Viti e nastro adesivo per il suo montaggio.',
      ],
    }
  },
  ZONIFIED : {
    title: 'Interfaccia per sistema zonificato',
    desc: 'Interfaccia di comunicazione per unità canalizzata regolata a zone',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
    articles: {
      COMMUNICATION_GATEWAY: {
        title: 'Interfaccia di comunicazione',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
        descResult: '',
      }
    },
    include: {
      pack1: 'Interfaccia di comunicazione Airzone - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Interfaccia di controllo 3.0 Airzone - %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  MONOZONE : {
    title: 'Modulo di zona per U.I. singola',
    desc: 'Modulo di zona per termostato via cavo/radio per il controllo di unità interna singola (solo per sistemi Acuazone)',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
    articles: {
      WIRED_ZONE_MODULE: {
        title: 'Modulo di zona a cavo Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
        descResult: '',
        conection: 'Cavo'
      },
      WIRELESS_ZONE_MODULE: {
        title: 'Modulo di zona radio Airzone',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxR.png',
        descResult: '',
        conection: 'Radio'
      }
    },
    include: {
      pack: '%{name} - %{protocolo}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Kit module di zona %{conection} Airzone %{protocolo} : <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  UNO_SYSTEM : {
    title: 'Sistemi UNO',
    desc: 'Scheda centrale + termostato cavo/radio per il controllo di unità interna singola',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PxxxBFCB.png',
    articles: {
      UNO_BLUEFACE_WHITE: {
        title: 'Pack Airzone UNO Blueface bianco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCB.png',
        descResult: '',
        type: 'Blueface',
        color: 'Bianco',
        conection: 'Cavo'
      },
      UNO_BLUEFACE_BLACK: {
        title: 'Pack Airzone UNO Blueface nero',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCN.png',
        descResult: '',
        type: 'Blueface',
        color: 'Nero',
        conection: 'Cavo'
      },
      UNO_THINK_WIRELESS_WHITE: {
        title: 'Pack Airzone UNO Think radio bianco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRB.png',
        descResult: '',
        type: 'Think',
        color: 'Bianco',
        conection: 'Radio'
      },
      UNO_THINK_WIRELESS_BLACK: {
        title: 'Pack Airzone UNO Think radio nero',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRN.png',
        descResult: '',
        type: 'Think',
        color: 'Nero',
        conection: 'Radio'
      },
      UNO_THINK_WIRED_WHITE: {
        title: 'Pack Airzone UNO Think cavo bianco',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCB.png',
        descResult: '',
        type: 'Think',
        color: 'Bianco',
        conection: 'Cavo'
      },
      UNO_THINK_WIRED_BLACK: {
        title: 'Pack Airzone UNO Think cavo nero',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCN.png',
        descResult: '',
        type: 'Think',
        color: 'Nero',
        conection: 'Cavo'
      }
    },
    include: {
      pack: 'Pack Airzone UNO %{protocolo} termostato %{type} (<a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>) con :',
      list1: 'Scheda centrale UNO %{type} %{conection} con interfaccia di comunicazione %{protocolo} integrata.',
      list2: 'Termostato Airzone %{type} %{conection} %{color}.',
      list3: 'Cavo bus Airzone 10 m.',
      list4: 'Batteria CR2450.',
    }
  },
  CompatibilityList: 'Elenco di compatibilità',
  SelectBrand: 'Seleziona la marca',
  SelectCompatibilityAirzone: 'Seleziona il tipo di compatibilità da verificare',
  SelectAtricleAirzone: 'Seleziona tipo di dispositivo/sistema',
  SelectIndoorUnitModel: 'Seleziona l\'unità interna',
  ResultUnid: 'Per l\'unità %{unid} (%{manufacturer})',
  ResultYourRefer: 'Il tuo codice Airzone è:',
  NamePdfFile: 'Airzone-compatibilita-riferimento',
  SelectInclude: 'La tua scelta include: ',
  ZoneSystem: 'Sistemi di zonificazione e regolazione Airzone',
  MonozoneController: 'Controllo unità individuali',
  List: 'Elencare',
  protocolo: {
    DA0: 'Daikin Residential',
    DA1: 'Daikin Sky Air / VRV',
    DA2: 'Daikin Altherma 3',
    FUJ: 'Fujitsu 3 wires',
    FU2: 'Fujitsu UART',
    GRE: 'Gree U-Match R410A',
    GR1: 'Gree U-Match R32',
    HAI: 'Haier',
    HIT: 'Hitachi RPI',
    HI2: 'Hitachi RAD',
    LGE: 'LG',
    MD1: 'Midea V5 protocol',
    MD2: 'Midea V6 protocol',
    MEL: 'Mitsubishi Electric',
    MHI: 'Mitsubishi Heavy',
    PA0: 'Panasonic RAC Domestic',
    PAN: 'Panasonic',
    TOS: 'Toshiba',
    SAM: 'Samsung',
    SA2: 'Samsung Nasa',
    HS1: 'Hisense',
    BAX: 'Baxi',
    BA1: 'Baxi R32',
    F3V: 'Fancoil 3 velocidades',
    FAN: 'Fancoil',
    IFR: 'IR',
    F10: 'Fancoil 0-10V',
    HI3: 'Hitachi Primairy',
    ME2: 'Mitsubishi Electric Ecodan',
  }
};
export default messages;
